export enum EngagementType {
  Anonymous = 'anonymous',
  Consultation = 'consultation',
  Direct = 'direct',
  Review = 'review',
}
